import { LocalizationEffects } from './localization.effects';

export const effects = [LocalizationEffects];

export { LocalizationEffects };
